module.exports = ".ui-panel-images {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.ui-galleria-panel {\r\n    width: 100%;\r\n    height: 100%;\r\n}"